var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6654 4L10.1294 7.3503L10.7358 8H13.2642L13.8706 7.3503L13.3346 4H10.6654ZM15.2 3L16 8L14.1333 10H9.86667L8 8L8.8 3L9.6 2H14.4L15.2 3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 19.7778V18.6667V16.1729L7.81046 14.2222H12V12H7L4 15.2323V22H6V19.7778Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9865 15.3586C19.999 15.2947 19.9999 15.2653 20 15.2653C19.9992 14.1129 18.9818 13 17.5 13C16.0182 13 15.0008 14.1129 15 15.2653C15.0001 15.2653 15.001 15.2947 15.0135 15.3586C15.0272 15.4291 15.0518 15.5251 15.0925 15.6483C15.175 15.8983 15.3063 16.2069 15.4884 16.5676C15.8536 17.2909 16.3611 18.1017 16.8989 18.8851C17.1011 19.1797 17.304 19.4651 17.5 19.7343C17.696 19.4651 17.8989 19.1797 18.1011 18.8851C18.6389 18.1017 19.1464 17.2909 19.5116 16.5676C19.6937 16.2069 19.825 15.8983 19.9075 15.6483C19.9482 15.5251 19.9728 15.4291 19.9865 15.3586ZM18.7653 21.3874C20.0963 19.6097 22 16.7993 22 15.2667C22 12.9103 19.9853 11 17.5 11C15.0147 11 13 12.9103 13 15.2667C13 16.7993 14.9037 19.6097 16.2347 21.3874C16.95 22.3429 17.5 23 17.5 23C17.5 23 18.05 22.3429 18.7653 21.3874Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonLocation);
export default __webpack_public_path__ + "static/media/person-location.dc7fa8028f083af81f53ed29bc1950aa.svg";
export { ForwardRef as ReactComponent };